import styled from 'styled-components'

export const InlineContainer = styled.div`
  display: flex;
`
